
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/member/login",
      function () {
        return require("private-next-pages/member/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/member/login"])
      });
    }
  